import axiosInstance from "../api";
import {
  GET_DASHBOARD,
  GET_PORTPOLIO,
  GET_PORTPOLIO_BY_ID,
  GET_PROFILE,
  GET_REPORT_BUSINESS,
  GET_REPORT_BUSINESS_GRAPH,
  GET_REPORT_OVERVIEW,
  GET_OVERVIEW_BUSINESS_GRAPH,
  GET_CONTRACT
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  getCurrentDate,
  getLastWeekDateRange,
} from "../../Components/Common/AllDateTimeReleventFormate";

export const getProfile = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auth/get-profile`);
    localStorage.setItem("role_type", response?.data?.response.role_type);
    if (response?.data?.status) {
      dispatch({ type: GET_PROFILE, profiledata: response?.data?.response });
      return;
    }
    // urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    // urtoast(err.message, 1);
  }
};

export const getContractPage = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`page?page=${type}`);
    if (response?.data?.status) {
      dispatch({ type: GET_CONTRACT, contractdata: response?.data?.response });
      return response?.data
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};


export const deleteProfile = (data) => async (dispatch) => {
  console.log(data, 'Payload');
  try {
    const response = await axiosInstance.post(`auth/account/delete`, data);
    return response;
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getDashboard = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`dashboard?type=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_DASHBOARD,
        dashboarddata: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getReportOverview = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `dashboard?type=2&start_date=${getLastWeekDateRange()}&end_date=${getCurrentDate()}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_REPORT_OVERVIEW,
        dashboardreportoverview: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getReportBusiness = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `dashboard?type=3&start_date=${getLastWeekDateRange()}&end_date=${getCurrentDate()}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_REPORT_BUSINESS,
        dashboardreportbusiness: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getReportBusinessGrapth =
  (start_date, end_date, type) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `dashboard?type=5&graph_type=${type}&start_date=${start_date}&end_date=${end_date}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_REPORT_BUSINESS_GRAPH,
          dashboardreportbusinessgraph: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      console.error();
      urtoast(err.message, 1);
    }
  };
export const getOverviewBusinessGrapth =
  (start_date, end_date, type) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `dashboard?type=4&graph_type=${type}&start_date=${start_date}&end_date=${end_date}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_OVERVIEW_BUSINESS_GRAPH,
          dashboardoverviewbusinessgraph: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      console.error();
      urtoast(err.message, 1);
    }
  };

export const updateProfile = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("auth/update-profile", data);
    if (response?.data?.status) {
      dispatch(getProfile());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getPortfolio = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`worksample`);
    localStorage.setItem("role_type", response?.data?.response.role_type);
    if (response?.data?.status) {
      dispatch({
        type: GET_PORTPOLIO,
        porpoliolistings: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getPortfoliobyId = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `worksample/id?work_sample_id=${id}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_PORTPOLIO_BY_ID,
        porpoliobyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const addPortfolio = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("worksample/create", data);
    if (response?.data?.status) {
      dispatch(getPortfolio());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const updatePortfolio = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("worksample/update", data);
    dispatch(getPortfolio());
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const deletePortfolio = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`worksample/delete?id=${id}`,);
    if (response?.data?.status) {
      dispatch(getPortfolio());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

